/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_search = /** @type {(inputs: {}) => string} */ () => {
	return `Hledat`
};

const da_search = /** @type {(inputs: {}) => string} */ () => {
	return `Søg`
};

const de_search = /** @type {(inputs: {}) => string} */ () => {
	return `Suchen`
};

const en_search = /** @type {(inputs: {}) => string} */ () => {
	return `Search`
};

const es_search = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar`
};

const fr_search = /** @type {(inputs: {}) => string} */ () => {
	return `Rechercher`
};

const hu_search = /** @type {(inputs: {}) => string} */ () => {
	return `Keresés`
};

const it_search = /** @type {(inputs: {}) => string} */ () => {
	return `Cerca`
};

const nl_search = /** @type {(inputs: {}) => string} */ () => {
	return `Zoeken`
};

const pl_search = /** @type {(inputs: {}) => string} */ () => {
	return `Szukaj`
};

const pt_search = /** @type {(inputs: {}) => string} */ () => {
	return `Pesquisar`
};

const sv_search = /** @type {(inputs: {}) => string} */ () => {
	return `Sök`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search", locale)
	if (locale === "cs") return cs_search(inputs)
	if (locale === "da") return da_search(inputs)
	if (locale === "de") return de_search(inputs)
	if (locale === "en") return en_search(inputs)
	if (locale === "es") return es_search(inputs)
	if (locale === "fr") return fr_search(inputs)
	if (locale === "hu") return hu_search(inputs)
	if (locale === "it") return it_search(inputs)
	if (locale === "nl") return nl_search(inputs)
	if (locale === "pl") return pl_search(inputs)
	if (locale === "pt") return pt_search(inputs)
	return sv_search(inputs)
};